import { render, staticRenderFns } from "./PAPostMapDialog.vue?vue&type=template&id=3b8e8326&"
import script from "./PAPostMapDialog.vue?vue&type=script&lang=js&"
export * from "./PAPostMapDialog.vue?vue&type=script&lang=js&"
import style0 from "./PAPostMapDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PAPostMapDialog.vue"
export default component.exports